module.exports = __webpack_public_path__ + "img/1.3ff18666.png";